/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    RoothashMessage,
    RoothashMessageFromJSON,
    RoothashMessageFromJSONTyped,
    RoothashMessageToJSON,
    RoothashMessageListAllOf,
    RoothashMessageListAllOfFromJSON,
    RoothashMessageListAllOfFromJSONTyped,
    RoothashMessageListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface RoothashMessageList
 */
export interface RoothashMessageList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof RoothashMessageList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof RoothashMessageList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<RoothashMessage>}
     * @memberof RoothashMessageList
     */
    roothash_messages: Array<RoothashMessage>;
}

export function RoothashMessageListFromJSON(json: any): RoothashMessageList {
    return RoothashMessageListFromJSONTyped(json, false);
}

export function RoothashMessageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoothashMessageList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'roothash_messages': ((json['roothash_messages'] as Array<any>).map(RoothashMessageFromJSON)),
    };
}

export function RoothashMessageListToJSON(value?: RoothashMessageList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'roothash_messages': ((value.roothash_messages as Array<any>).map(RoothashMessageToJSON)),
    };
}


